import { postData } from '../ApiServices/ApiService';
import { ORG_CHECK_DEVICE_ORG_STATUS, ORG_FRONTEND_EXCEPTION } from '../ApiServices/BaseURL';

/**
 * Logs frontend exceptions to the backend
 * @param {Object} errorInfo - Details of the exception
 * @param {string} errorInfo.methodName - Function or API method where error occurred
 * @param {string} errorInfo.pageName - Component or screen name
 * @param {string} errorInfo.emp_id_auth - User ID
 * @param {any} errorInfo.response - Error object or failed response
 */
export const logFrontendException = async ( emp_id_auth, pageName, methodName, response ) => {
  try {
    const payload = {
      emp_id_auth: emp_id_auth || null,
      page_name: pageName,
      method_name: methodName,
      response: typeof response === 'string' ? response : JSON.stringify(response),
      timestamp: new Date().toISOString()
    };

    await postData(ORG_FRONTEND_EXCEPTION, payload);
  } catch (e) {
    // Optional: fallback log
    console.error("Failed to log exception:", e);
  }
};

export const logOutApiCall = async ( emp_id_auth, reason ) => {
  try {
    const payload = {
      action:'log_out',
      emp_id_auth: emp_id_auth || 0,
      reason: reason,
    };

    await postData(ORG_CHECK_DEVICE_ORG_STATUS, payload);
  } catch (e) {
    // Optional: fallback log
    console.error("Failed to log out exception:", e);
  }
};
